import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable"

import "rxjs/add/operator/map";
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class GeneralApiService {
    constructor(private generalApi: AuthHttp) {}
    
    GetMainDealerList(){
        return this.generalApi.get(environment.apiEndPoint + `/GetListMainDealer`)
          .map((response : Response) => response.json())
    }
}


// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/GeneralApi.service.ts